import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {PrimaryBigButton} from "../../components/buttons/mainButton";
import Page from "../../patterns/page/page";
import AddSvg from "../../assets/wizard/operation/add.svg";
import * as React from "react";
import {sendEmailContact} from "../../services/EmailContactService";

type SendEmailContactProps = {
  openDialog: boolean,
  closeDialog: () => void,
  sendMail: (email: string) => Promise<void>,
  email: string,
}

export const BlockedOperationPage = ({
  closeDialog,
}: SendEmailContactProps): JSX.Element => {
  const {t} = useTranslation();
  const handleClick = async (): Promise<void> => {
    try {
      sendEmailContact({askContact:true});
    } finally {
      window.open("https://bookings.cloud.microsoft/book/AGENCELIBERTYRDVCLIENTS@tradeunion91.onmicrosoft.com/?ismsaljsauthenabled","_blank");
      closeDialog();
    }
  };
  return (
    <Page title={t("operations.blocked_page.title")}>
      <Box sx={{px: 10, pb: 10, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "100%"}}>
        <Box sx={{textAlign: "center", mt: 4}}>
          {/* @ts-ignore */}
          <img src={AddSvg} alt="" />
          <Typography variant="h1" sx={{fontWeight: "bold", mt: 2}}>
            {t("operations.blocked_page.title")}
          </Typography>
          <Typography
            variant="body2"
            sx={{mt: 2}}
            dangerouslySetInnerHTML={{__html: t("operations.blocked_page.content")}}
          />
          <div onClick={handleClick} style={{width: "100%", display: "flex", justifyContent: "center"}}>
            <PrimaryBigButton
              label={t("operations.blocked_operation.button_label")}
              sx={{mt: 2}}
            />
          </div>
        </Box>
      </Box>
    </Page>
  );
};
